import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
} from '@material-ui/core'
import React, { FC } from 'react'

import { cn } from './utils/cn'

import CloseIcon from '../img/icons/close.svg'

interface ModalProps {
  title?: string | null
  cta?: React.ReactNode
  content?: React.ReactNode
  disabled?: boolean
  isOpen: boolean
  onClose?: () => void
  className?: string
  maxWidth?: DialogProps['maxWidth']
}

const Modal: FC<ModalProps> = ({
  children,
  content,
  disabled,
  maxWidth = 'sm',
  title,
  cta,
  isOpen,
  onClose,
  className,
}) => {
  return (
    <Dialog
      aria-describedby="scroll-dialog-description"
      aria-labelledby="scroll-dialog-title"
      fullWidth
      maxWidth={maxWidth}
      onClose={onClose}
      scroll="paper"
      open={isOpen}
      className={cn('!z-[999999999]', className)}
    >
      <DialogContent>
        <DialogContentText component="section" id="scroll-dialog-description" tabIndex={-1}>
          <div className="flex flex-col items-start font-gotham pt-4 pb-2 text-black">
            {title && <h3 className="text-2xl text-brand-navy font-semibold mb-8">{title}</h3>}
            {content}
            {children}
          </div>
        </DialogContentText>
        {onClose && (
          <button onClick={onClose} className="absolute right-4 top-4" disabled={disabled}>
            <img src={CloseIcon} alt="Close" />
          </button>
        )}
      </DialogContent>
      <DialogActions className="flex border-t border-t-brand-rule-grey justify-end p-6">
        {cta}
      </DialogActions>
    </Dialog>
  )
}

export default Modal
